﻿import $ from "jquery";
import ko from "knockout";

export default class ProductModel {
	constructor(product, options) {
		const _ = this;

		_.options = options;

		_.name = product.name;
		_.tabSysName = product.categoryName;
		_.url = product.url;
		_.target = product.target;
		_.partno = product.partNumber;
		_.info = product.info || {};
		_.clickEvent = product.clickEvent;
		_.addToCart = product.addToCart;

		if (_.options.parsingPriceJs) {
			_.addToCartShown = ko.observable(!options.showAddToCartWithPrice);
			_.productLinkShown = ko.observable(!options.showLinkWithPrice);
			_.price = ko.observable(product.price.value);
		} else {
			_.addToCartShown = !options.showAddToCartWithPrice || product.price.value;
			_.productLinkShown = !options.showLinkWithPrice || product.price.value;

			_.price = product.price.value || options.priceFallbackText;
		}

		_.priceParam = product.price;
		_.priceLoading = ko.observable(false);
		_.priceFallbackText = options.priceFallbackText;
	}

	logEvent(data) {
		if (!data.clickEvent) {
			return false;
		}

		let parsingPriceData = null;

		if (this.parsed) {
			parsingPriceData = { price: this.price(), dynamicPrice: true };
		}

		const actionContext = JSON.parse(ccs_cc_log.getEventParams(data.clickEvent)["ActionContext"]);
		$.extend(actionContext, parsingPriceData, { sourceTab: this.tabSysName });

		const clientParams = { ActionContext: JSON.stringify(actionContext) };

		ccs_cc_log.dispatchEvent(data.clickEvent, clientParams);

		return true;
	}

	parsePrice() {
		const _ = this;

		if (!_.priceParam.url || !_.options.parsingPriceJs || _.parsed) {
			return;
		}
		_.parsed = true;

		const logoProgram = window.CcsLogoProgram;

		if (logoProgram) {
			_.priceLoading(true);

			logoProgram.requestPrice(
				(data) => {
					if (data && data.result) {
						_.price(data.result);
						_.addToCartShown(true);
						_.productLinkShown(true);
					} else {
						_.price(_.priceFallbackText);
					}

					_.priceLoading(false);
				},
				_.priceParam.url,
				_.options.parsingPriceJs,
				_.priceParam.errorLogCall);
		}
	}
}
